import {
  ExtendedTemplateItemOptions,
  FilenameTemplateItem,
} from './FilenameTemplateItem'

type Project = {
  projectName?: string
  clientProjectNumber?: string
  clientProjectName?: string
}
export class ProjectFilenameTemplateItem<
  Property extends keyof Project,
  ID extends string
> extends FilenameTemplateItem<Project, 'Project', Property, ID> {
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(options: ExtendedTemplateItemOptions<Project, Property, ID>) {
    super({ classType: 'Project', ...options })
  }
}
